import { render, staticRenderFns } from "./linkAddress.vue?vue&type=template&id=19436ec6&"
import script from "./linkAddress.vue?vue&type=script&lang=js&"
export * from "./linkAddress.vue?vue&type=script&lang=js&"
import style0 from "./linkAddress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports